module.exports = __webpack_public_path__ + "img/declare1.9b65c218.jpg";